var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.6,
    height: 19.6,
    viewBox: "0 0 19.6 19.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3229",
    "data-name": "Group 3229",
    transform: "translate(-309.2 -737.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1757",
    "data-name": "Rectangle 1757",
    d: "M1.636-.8H4.909A2.439,2.439,0,0,1,7.345,1.636V4.909A2.439,2.439,0,0,1,4.909,7.345H1.636A2.439,2.439,0,0,1-.8,4.909V1.636A2.439,2.439,0,0,1,1.636-.8ZM4.909,5.745a.837.837,0,0,0,.836-.836V1.636A.837.837,0,0,0,4.909.8H1.636A.837.837,0,0,0,.8,1.636V4.909a.837.837,0,0,0,.836.836Z",
    transform: "translate(321.455 738)",
    fill: "#52ff02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1756",
    "data-name": "Rectangle 1756",
    d: "M1.636-.8H4.909A2.439,2.439,0,0,1,7.345,1.636V4.909A2.439,2.439,0,0,1,4.909,7.345H1.636A2.439,2.439,0,0,1-.8,4.909V1.636A2.439,2.439,0,0,1,1.636-.8ZM4.909,5.745a.837.837,0,0,0,.836-.836V1.636A.837.837,0,0,0,4.909.8H1.636A.837.837,0,0,0,.8,1.636V4.909a.837.837,0,0,0,.836.836Z",
    transform: "translate(310 738)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1758",
    "data-name": "Rectangle 1758",
    d: "M1.636-.8H4.909A2.439,2.439,0,0,1,7.345,1.636V4.909A2.439,2.439,0,0,1,4.909,7.345H1.636A2.439,2.439,0,0,1-.8,4.909V1.636A2.439,2.439,0,0,1,1.636-.8ZM4.909,5.745a.837.837,0,0,0,.836-.836V1.636A.837.837,0,0,0,4.909.8H1.636A.837.837,0,0,0,.8,1.636V4.909a.837.837,0,0,0,.836.836Z",
    transform: "translate(310 749.455)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1759",
    "data-name": "Rectangle 1759",
    d: "M1.636-.8H4.909A2.439,2.439,0,0,1,7.345,1.636V4.909A2.439,2.439,0,0,1,4.909,7.345H1.636A2.439,2.439,0,0,1-.8,4.909V1.636A2.439,2.439,0,0,1,1.636-.8ZM4.909,5.745a.837.837,0,0,0,.836-.836V1.636A.837.837,0,0,0,4.909.8H1.636A.837.837,0,0,0,.8,1.636V4.909a.837.837,0,0,0,.836.836Z",
    transform: "translate(321.455 749.455)",
    fill: "#16161a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.96c7aa4ebb1e2f9a0b4a4e8638f3dfcf.svg";
export { ForwardRef as ReactComponent };